import * as constants from '../components/Constants'
import cartLogo from '../assets/Text/CART/KYLIE_COSMETICS_by_KJ_Logo.png'
import cartTitle from '../assets/Text/CART/CART.png'
import cartCheckoutButton from '../assets/Text/CART/CHECK_OUT.png'
import cartCross from '../assets/Icons/CROSS_WHITE.png'

import bluegelpencil from '../assets/Images/PRODUCTS/ITEMS/MATTE_BLUE_KYLINER_GEL_PENCIL.png'
import mattelipstick from '../assets/Images/PRODUCTS/ITEMS/KOKO_K_MATTE_LIQUID_LIPSTICK.png'
import brownpencil from '../assets/Images/PRODUCTS/ITEMS/MEDIUM_BROWN_KYBROW_PENCIL.png'
import winterpowder from '../assets/Images/PRODUCTS/ITEMS/WINTER_KISSED_PRESSED_BLUSH_POWDER.png'
import blackpen from '../assets/Images/PRODUCTS/ITEMS/BLACK_KYLINER_LIQUID_PEN.png'
import mattelipkit from '../assets/Images/PRODUCTS/ITEMS/KYLIE_MATTE_LIP_KIT.png'
import baddiepowder from '../assets/Images/PRODUCTS/ITEMS/BADDIE_ON_THE_BLOCK_PRESSED_BLUSH_POWDER.png'
import coolbrownpencil from '../assets/Images/PRODUCTS/ITEMS/COOL_BROWN_KYBROW_PENCIL.png'
import divagloss from '../assets/Images/PRODUCTS/ITEMS/DIVA_HIGH_GLOSS.png'
import tequilapowder from '../assets/Images/PRODUCTS/ITEMS/TEQUILA_TAN_PRESSED_BRONZING_POWDER.png'
import pinkpowder from '../assets/Images/PRODUCTS/ITEMS/PINK_POWER_PRESSED_BLUSH_POWDER.png'
import crushpowder from '../assets/Images/PRODUCTS/ITEMS/CRUSH_PRESSED_BLUSH_POWDER.png'
import kittenpowder from '../assets/Images/PRODUCTS/ITEMS/KITTEN_BABY_PRESSED_BLUSH_POWDER.png'
import auburnpencil from '../assets/Images/PRODUCTS/ITEMS/AUBURN_KYBROW_PENCIL.png'
import deeppencil from '../assets/Images/PRODUCTS/ITEMS/DEEP_BROWN_KYBROW_PENCIL.png'
import blondepencil from '../assets/Images/PRODUCTS/ITEMS/BLONDE_KYBROW_PENCIL.png'
import ebonypencil from '../assets/Images/PRODUCTS/ITEMS/EBONY_KYBROW_PENCIL.png'
import snowlipkit from '../assets/Images/PRODUCTS/ITEMS/SNOW_WAY_BAE_MATTE_LIP_KIT.png'
import bitelipkit from '../assets/Images/PRODUCTS/ITEMS/BITE_ME_MATTE_LIP_KIT.png'
import sweaterlipkit from '../assets/Images/PRODUCTS/ITEMS/SWEATER_WEATHER_MATTE_LIP_KIT.png'
import bosslipkit from '../assets/Images/PRODUCTS/ITEMS/BOSS_MATTE_LIP_KIT.png'
import victorialipkit from '../assets/Images/PRODUCTS/ITEMS/VICTORIA_MATTE_LIP_KIT.png'
import betternotpout from '../assets/Images/PRODUCTS/ITEMS/BETTER_NOT_POUT_MATTE_LIP_KIT.png'
import posielipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/EXTRAORDINARY_MATTE_LIP_KIT.png' // ### !!! Wrong - awaiting asset!
import extraordinarylipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/EXTRAORDINARY_MATTE_LIP_KIT.png'
import kokolipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/KOKO_K_MATTE_LIP_KIT.png'
import angellipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/ANGEL_MATTE_LIP_KIT.png'
import maryjolipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/MARY_JO_K_MATTE_LIP_KIT.png'
import badlilthinglipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/BAD_LIL_THING_MATTE_LIP_KIT.png'
import hollyberrylipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/HOLLYBERRY_MATTE_LIP_KIT.png'
import autumnlipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/AUTUMN_MATTE_LIP_KIT.png'
import twentylipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/TWENTY_MATTE_LIP_KIT.png'
import barelipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/BARE_MATTE_LIP_KIT.png'
import exposedlipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/EXPOSED_MATTE_LIP_KIT.png'
import onewishlipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/ONE_WISH_MATTE_LIP_KIT.png'
import queenlipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/QUEEN_MATTE_LIP_KIT.png'
import candylipkit from '../assets/Images/PRODUCTS/ITEMS/Additional/CANDY_K_MATTE_LIP_KIT.png'
import bubblypg from '../assets/Images/PRODUCTS/PACKS/KJC_PGLOSS_22_Bubbly_817_3.22ml_0.png'
import roseandchillpg from '../assets/Images/PRODUCTS/PACKS/KJC_PGLOSS_22_Rose_And_Chill_342_3.22ml_0.png'
import onneutralpg from '../assets/Images/PRODUCTS/PACKS/KJC_PGLOSS_22_On_Neutral_730_3.22ml_0.png'
import notyourbaepg from '../assets/Images/PRODUCTS/PACKS/KJC_PGLOSS_22_Not_Your_Bae_729_3.22ml_0.png'
import moodyqueenpg from '../assets/Images/PRODUCTS/PACKS/KJC_PGLOSS_22_Moody_Queen_110_3.22ml_0.png'
import curvehimpg from '../assets/Images/PRODUCTS/PACKS/KJC_PGLOSS_22_Curve_Him_617_3.22ml_0.png'
import bronzepalette from '../assets/Images/PRODUCTS/PACKS/KJC_KSHAD_22_Palette_Bronze_pack_solo.png'
import mauvepalette from '../assets/Images/PRODUCTS/PACKS/KJC_KSHAD_22_Palette_Mauve_pack_solo.png'

import { playClickSound } from '../components/Sound'


import Plausible from 'plausible-tracker'
import { PlausibleState } from '../components/PlausibleState'

const { trackEvent } = Plausible({
  domain: 'kylie-world.netlify.app',
  trackLocalhost: true
}) 


const productImages =
[
  null,
  bluegelpencil,
  mattelipstick,
  brownpencil,
  winterpowder,
  blackpen,
  mattelipkit,
  baddiepowder,
  coolbrownpencil,
  divagloss,
  tequilapowder,
  pinkpowder,
  crushpowder,
  kittenpowder,
  auburnpencil,
  deeppencil,
  blondepencil,
  ebonypencil,
  snowlipkit,
  bitelipkit,
  sweaterlipkit,
  bosslipkit,
  victorialipkit,
  betternotpout,
  posielipkit,
  extraordinarylipkit,
  kokolipkit,
  angellipkit,
  maryjolipkit,
  badlilthinglipkit,
  hollyberrylipkit,
  autumnlipkit,
  twentylipkit,
  barelipkit,
  exposedlipkit,
  onewishlipkit,
  queenlipkit,
  candylipkit,
  bubblypg,
  roseandchillpg,
  onneutralpg,
  notyourbaepg,
  moodyqueenpg,
  curvehimpg,
  bronzepalette,
  mauvepalette
]

export function ShoppingCart(props) {
  // Note that shade indices need + 1 to get to a real shade color.
  // shade 0 = no shade (i.e. no product).


  const itemCount = props.cartContents.reduce((a,b) => a+b);
  let items
  let checkoutButton

  function clickCheckoutButton() {

    playClickSound();

    trackEvent("Visit Checkout", {
      callback: () => console.log("track plausible visit checkout", PlausibleState.getNumberProductTries()),
      props: {
        itemCount: itemCount,
        speed: navigator.connection ? navigator.connection.downlink : undefined,
        productTries: PlausibleState.getNumberProductTries(),
        timeInVTO: PlausibleState.getTimeInVTO()
      }
    })

    
    // slight delay to allow for sound to play.
    setTimeout(() => {
      props.updatePage(constants.REACT_PAGE_FINAL_CHECKOUT)
    }, 200);
  }

  if (itemCount > 0) {
    
    items = props.cartContents.map((count, productIndex) => (
    <>
      {(count > 0)
        ? <CartItem
         product={productIndex}
         addItem={props.addItem}
         removeItem={props.removeItem}
         count={count}/>
        : null}
    </>
    ))

    checkoutButton = (
      <div className='checkOutButton' onClick= {clickCheckoutButton}>
          <img alt="" className='checkOutButtonImage' src={cartCheckoutButton}/>
        </div>
      )
  }
  else {
    items = "YOUR CART IS EMPTY"

    checkoutButton = (
      <div className='checkOutButtonDisabled'>
          <img alt="" className='checkOutButtonImage' src={cartCheckoutButton}/>
        </div>
      )
  }

  return (
    <div className='fullscreen'>  {/* white background behind cart makes for smoother transition in case of
                                     any delays, compared to camera feed */}
      <div className='cartBackground'>
        <div className='iconTopLeft' onClick= {() => { playClickSound(); props.updatePage(props.lastPage)}}>
          <img alt="" className='iconImage' src={cartCross}/>
        </div>
        <div className='cartHeading'>
          <img alt="" className='checkOutLogoImage' src={cartLogo}/>
          <img alt="" className='checkOutTitleImage' src={cartTitle}/>
        </div>
        <div className='cartScrollablePanel'>
          {items}
        </div>
        {checkoutButton}
      </div>
    </div>
  )
}

function CartItem(props) {
  return (
    <>
      <div className='cartItemPanel'>
        <div className='cartItemLeftPanel'>
          <img alt="" className='cartItemLeftPanelImage' src = {productImages[props.product]}/>
        </div>
        <div className='cartItemCenterPanel'>
          <div className='cartItemCenterPanelName'>{constants.PRODUCTS[props.product].name}</div>
        </div>
        <div className='cartItemRightPanel'>
          <div className='cartAdjusterPlus'
                  onClick={() => {playClickSound(); props.addItem(props.product)}}>
            +
          </div>
          <div className='cartItemCount'>
            {props.count}
          </div>
          <div className='cartAdjusterMinus'
                  onClick={() => {playClickSound(); props.removeItem(props.product)}}>
            -
          </div>
        </div>
      </div>
    </>
  )
}